/**
 * 查词页、游戏内查词弹窗、自然拼读 — TTS 音色策略（代码内开关，非用户设置）
 *
 * 仅影响上述三个模块；游戏练习（朗读/词卡/Ctrl+A 等）仍走用户自定义音色。
 */
import {
  LEARNING_MODULE_FIXED_UK_VOICE,
  LEARNING_MODULE_FIXED_US_VOICE
} from '@/config/ttsVoices'
import { DEFAULT_TTS_UI_SPEED } from '@/utils/ttsRequest'

/** true = 跟随 getUserSettings 的 speaker / 语速 / 音量；false = 使用下方 FIXED_TTS */
export const LEARNING_MODULE_USE_USER_TTS_SETTINGS = false

/**
 * LEARNING_MODULE_USE_USER_TTS_SETTINGS 为 false 时生效。
 * speakerByLocale：查词「英」「美」按钮分别使用的固定音色；
 * 例句/拼读无 locale 时用 speaker（默认美式 Heart；点「英」才用 Emma）。
 */
export const LEARNING_MODULE_FIXED_TTS = {
  speaker: LEARNING_MODULE_FIXED_US_VOICE,
  speakerByLocale: {
    uk: LEARNING_MODULE_FIXED_UK_VOICE,
    us: LEARNING_MODULE_FIXED_US_VOICE
  },
  speed: DEFAULT_TTS_UI_SPEED,
  volume: 1
}
